<!--
  Layout displayed when the user is not logged in
-->
<template>
  <stack>
    <onboarding-header ref="header" :region-data="regionData" />
    <div class="flex-grow">
      <slot />
    </div>
    <login-site-footer />
  </stack>
</template>

<script>
import Stack from "@/components/layout/common/Stack.vue";
import OnboardingHeader from "@/components/application/OnboardingHeader.vue";
import LoginSiteFooter from "@/components/application/LoginSiteFooter.vue";

export default {
  components: { OnboardingHeader, Stack, LoginSiteFooter },
  props: {
    regionData: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    openRegionSelectionModal() {
      const header = this.$refs["header"];
      if (header) {
        header.onRegionSelect();
      }
    },
  },
};
</script>
